/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 本体商品契約情報
 */
export interface Szma103aResponseElecCtrSearchResultDtoHontiGoodsInfo {
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 商品契約利用開始日付：日付(yyyyMMdd)
     */
    useStartDate?: string;
    /**
     * 商品契約利用終了日付：日付(yyyyMMdd)
     */
    useEndDate?: string;
    /**
     * 商品契約満了予定日付：日付(yyyyMMdd)
     */
    ctrExpireDate?: string;
    /**
     * プロダクト商品正式名称：全角
     */
    prdGoodsAname?: string;
    /**
     * プロダクト商品略称名称：全角
     */
    prdGoodsRyaku?: string;
    /**
     * プロダクト商品画面用名称：全角
     */
    prdGoodsDisp?: string;
    /**
     * 請求確定番号：数字
     */
    claimFixNo?: string;
}

